import { render, staticRenderFns } from "./TraineeYears.vue?vue&type=template&id=13ae3e70&"
import script from "./TraineeYears.vue?vue&type=script&lang=js&"
export * from "./TraineeYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports